import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

const withCredentials = (params, userLSToken: string) => {
  // For some reason when loading components 'on the fly' the interceptor
  // is not adding the token, so adding (next 2 lines) this to ensure we send the right headers
  const userToken = localStorage.getItem(userLSToken);
  const headers = { Authorization: `Bearer ${userToken}` };
  return { ...params, headers };
};

export const resourceLoader = (
  userLSToken: string,
  http: HttpClient,
  blobObjectCreator: Function,
  baseUrl: string,
  uri: string,
  params?: any
): Observable<Object> => {
  // Check if the URI contains 'assets/svg/'
  if (uri.includes('assets/svg/')) {
    baseUrl = baseUrl.replace('cepapi/api', '').replace(/\/$/, '');
  }
  // Replace '/blob' with 'blob' in the URI
  uri = uri.replace('/blob', 'blob');

  // If the URI starts with 'blob:', do not prepend the baseUrl
  const finalUrl = uri.startsWith('blob:') || uri.startsWith('/blob:') ? uri : baseUrl + uri;
  return http.get(finalUrl, withCredentials(params, userLSToken)).pipe(
    take(1),
    catchError(error => throwError(error.error)),
    map(e => blobObjectCreator(e))
  );
};

export const resourceLoaderFactory = (
  http: HttpClient,
  blobObjectCreator: Function,
  userLSToken: string,
  baseUrl: string
) => resourceLoader.bind(null, userLSToken, http, blobObjectCreator, baseUrl);
